import * as Yup from 'yup'

export const schemaSupplyPayment = (t: (key: string) => string) => ({
  currency: Yup.string().required(t('requiredMessage')),
  value: Yup.string().required(t('requiredMessage')),
  type: Yup.string().required(t('requiredMessage')),
})
